<template>
  <div id="map">
  	<home-header :navName="navName"></home-header>
  	<div id="bodyer">
  		<ul class="mapMenu">
        <li v-for="(liName,index) in liNames" @click="mapType=index;tabShow(index)" :class="{active:mapType==index}">{{liName}}</li>
      </ul>
      <div class="mapContent">
        <ul>
          <div class="typeTitle">栅格地图(<span class="num">{{rasterDatas.length}}</span>)</div>
          <li v-for="rasterData in rasterDatas.slice(0,raPage+8)">
            <a :href="rasterData.example_url?rasterData.example_url:'javascript:;'" target="_blank">
            <img :src="rasterData.imgUrl" :alt="rasterData.gcms_title">
            <p><span class="name">{{rasterData.gcms_title}}</span><span class="time">{{rasterData.gcms_create_time}}</span></p></a>
          </li>

          <div class="moreData" v-show="rasterDatas.length > 0"><button @click="raPage+=8">更多></button></div>
        </ul>
        <ul>
          <div class="typeTitle">矢量地图(<span class="num">{{vectorDatas.length}}</span>)</div>
          <li v-for="vectorData in vectorDatas.slice(0,vePage+8)">
            <a :href="vectorData.example_url?vectorData.example_url:'javascript:;'" target="_blank">
            <img :src="vectorData.imgUrl" :alt="vectorData.gcms_title">
            <p><span class="name">{{vectorData.gcms_title}}</span><span class="time">{{vectorData.gcms_create_time}}</span></p></a>
          </li>
          <div class="moreData" v-show="vectorDatas.length > 0"><button @click="vePage+=8">更多></button></div>
        </ul>
        <ul>
          <div class="typeTitle">三维场景地图(<span class="num">{{threeDatas.length}}</span>)</div>
          <li v-for="threeData in threeDatas.slice(0,thrPage+8)">
            <a :href="threeData.example_url?threeData.example_url:'javascript:;'" target="_blank">
            <img :src="threeData.imgUrl" :alt="threeData.gcms_title">
            <p><span class="name">{{threeData.gcms_title}}</span><span class="time">{{threeData.gcms_create_time}}</span></p></a>
          </li>

          <div class="moreData" v-show="threeDatas.length > 0"><button @click="thrPage+=8">更多></button></div>
        </ul>

        <ul>
          <div class="typeTitle">地图集(<span class="num">{{atlasDatas.length}}</span>)</div>
          <li v-for="atlasData in atlasDatas.slice(0,atPage+8)">
            <a :href="atlasData.example_url?atlasData.example_url:'javascript:;'" target="_blank">
            <img :src="atlasData.imgUrl" :alt="atlasData.gcms_title">
            <p><span class="name">{{atlasData.gcms_title}}</span><span class="time">{{atlasData.gcms_create_time}}</span></p></a>
          </li>

          <div class="moreData" v-show="atlasDatas.length > 0"><button @click="atPage+=8">更多></button></div>
        </ul>

        <ul>
          <div class="typeTitle">系列图(<span class="num">{{groupDatas.length}}</span>)</div>
          <li v-for="groupData in groupDatas.slice(0,grPage+8)">
            <a :href="groupData.example_url?groupData.example_url:'javascript:;'" target="_blank">
            <img :src="groupData.imgUrl" :alt="groupData.gcms_title">
            <p><span class="name">{{groupData.gcms_title}}</span><span class="time">{{groupData.gcms_create_time}}</span></p></a>
          </li>

          <div class="moreData" v-show="groupDatas.length > 0"><button @click="grPage+=8">更多></button></div>
        </ul>

        <ul>
          <div class="typeTitle">地图对(<span class="num">{{twinDatas.length}}</span>)</div>
          <li v-for="twinData in twinDatas.slice(0,twPage+8)">
            <a :href="twinData.example_url?twinData.example_url:'javascript:;'" target="_blank">
            <img :src="twinData.imgUrl" :alt="twinData.gcms_title">
            <p><span class="name">{{twinData.gcms_title}}</span><span class="time">{{twinData.gcms_create_time}}</span></p></a>
          </li>

          <div class="moreData" v-show="twinDatas.length > 0"><button @click="twPage+=8">更多></button></div>
        </ul>

        <ul>
          <div class="typeTitle">单幅图(<span class="num">{{thematicmapDatas.length}}</span>)</div>
          <li v-for="thematicmapData in thematicmapDatas.slice(0,thePage+8)">
            <a :href="thematicmapData.example_url?thematicmapData.example_url:'javascript:;'" target="_blank">
            <img :src="thematicmapData.imgUrl" :alt="thematicmapData.gcms_title">
            <p><span class="name">{{thematicmapData.gcms_title}}</span><span class="time">{{thematicmapData.gcms_create_time}}</span></p></a>
          </li>

          <div class="moreData" v-show="thematicmapDatas.length > 0"><button @click="thePage+=8">更多></button></div>
        </ul>

        <ul>
          <div class="typeTitle">地理实体分布图(<span class="num">{{geoentryDatas.length}}</span>)</div>
          <li v-for="geoentryData in geoentryDatas.slice(0,gePage+8)" @click="showInfosClick(geoentryData.content)">
            <a :href="geoentryData.example_url?geoentryData.example_url:'javascript:;'" target="_blank">
            <img :src="geoentryData.imgUrl" :alt="geoentryData.gcms_title">
            <p><span class="name">{{geoentryData.gcms_title}}</span><span class="time">{{geoentryData.gcms_create_time}}</span></p></a>
          </li>

          <div class="moreData" v-show="geoentryDatas.length > 0"><button @click="gePage+=8">更多></button></div>
        </ul>

      </div>

  	</div>
    <connect-part></connect-part>
    <home-footer></home-footer>
    <div id="infosContent"
            v-show="infosContent"
    >
      <div class="cell">
        <div class="cover"></div>
        <div class="content">
          <div class="header">
             <div class="close" title="关闭" @click="closeInfoClick()">X</div>
          </div>
          <div class="body" v-html="infosContentHtml">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import HomeHeader from './header'
import ConnectPart from './connect'
import HomeFooter from './footer'
export default {
  name: 'map',
  components:{
  	HomeHeader:HomeHeader,
    ConnectPart:ConnectPart,
    HomeFooter:HomeFooter
  },
  data: function() {
  		return {
        liNames:["栅格地图","矢量地图","三维场景地图","地图集","系列图","地图对","单幅图","地理实体分布图"],
  			listdata:"",
  			navName:"map",
        mapType:0,
        sortList:[["dt_raster"],["dt_vector"],["dt_3d"],["dt_atlas"],["dt_group"],["dt_twin"],["dt_thematicmap"],["dt_geoentry"]],
        atlasDatas:[],
        atPage:0,
        groupDatas:[],
        grPage:0,
        twinDatas:[],
        twPage:0,
        rasterDatas:[],
        raPage:0,
        vectorDatas:[],
        vePage:0,
        threeDatas:[],
        thrPage:0,
        thematicmapDatas:[],
        thePage:0,
        geoentryDatas:[],
        gePage:0,
        infosContentHtml:null,
        infosContent:false,
        jIndex:0
  		}
  },
  methods:{
    tabShow:function(index){
      var topHeight = 0;
      if(index == 0){
        $("html").scrollTop(0);
      } else{
        for(var i=1;i<=index;i++){
          topHeight+=($(".mapContent ul").eq(i-1).get(0).clientHeight+40);//加单个外边距
        }
        $("html").scrollTop(topHeight);
      }
    },
    showInfosClick:function(data){
      this.infosContent = true;
      this.infosContentHtml = data;
    },
    closeInfoClick:function(){
      this.infosContent = false;
    },
  	getGcmsList:function(){
      var that = this;
      var sortList = that.sortList;
      for(var i=0;i<sortList.length;i++){
        ((function(i){
        // console.log(sortList[i])
        // axios.get(xdc_app_config.gcms_server+'/content/'+sortList[i]).then(this.getLength)//126
          var url = xdc_app_config.gcms_server+'/content/'+sortList[i];
          $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json'
          })
          .done(function(data) {
            // console.log(data);
            var length = data.total;
            var sortData = data.data;
            if(length >= 0){
              $(sortData).each(function(j,item){
                var innerUrl = xdc_app_config.gcms_server+'/content/'+sortList[i]+'/'+item.gcms_id;
                $.ajax({
                  url: innerUrl,
                  type: 'GET',
                  dataType: 'json'
                })
                .done(function(data) {
                  if(data.data){
                    that.updateData(data.data,sortList[i])
                  }
                })
                .fail(function() {
                  // console.log("error");
                })
              })
            }
          })
          .fail(function() {
            // console.log("error");
          })
        }(i)));
      }
  	},
  	updateData:function(data,activeSort){
      var that = this;
      var mapData = data;
      var options = {};
      if(mapData){
        // console.log(mapData);
        options.imgUrl = xdc_app_config.gcms_server+'/file'+mapData.thumbnail;
        options.gcms_title = mapData.gcms_title;
        options.introduction = mapData.introduction;
        options.gcms_create_time = that.fmtDate(mapData.gcms_create_time);
        options.example_url = mapData.example_url;
        if(activeSort == 'dt_atlas'){
          that.atlasDatas.push(options)
        } else if(activeSort == 'dt_group'){
          that.groupDatas.push(options)
        } else if(activeSort == 'dt_twin'){
          that.twinDatas.push(options)
        } else if(activeSort == 'dt_raster'){
          that.rasterDatas.push(options)
        } else if(activeSort == 'dt_vector'){
          that.vectorDatas.push(options)
        } else if(activeSort == 'dt_3d'){
          that.threeDatas.push(options)
        } else if(activeSort == 'dt_thematicmap'){
          that.thematicmapDatas.push(options)
        } else if(activeSort == 'dt_geoentry'){
          options.content = mapData.content;
          that.geoentryDatas.push(options)
          //console.log(mapData)
        }

      }
  	},
    fmtDate:function(obj){
      var date =  new Date(obj);
      var y = 1900+date.getYear();
      var m = "0"+(date.getMonth()+1);
      var d = "0"+date.getDate();
      return y+"-"+m.substring(m.length-2,m.length)+"-"+d.substring(d.length-2,d.length);
    }

  },
  mounted:function(){
  	this.getGcmsList();
  },
  updated:function(){
    var arry = $('#infosContent').find('img');
    for(var i=0;i< arry.length;i++){
      var src = arry.eq(i).attr('src');
      if(src){
        $(arry.eq(i)).attr('src',src);
      }
    }
  }
}
</script>
<style scoped>
@import "../../assets/styles/map.css";
</style>



// WEBPACK FOOTER //
// src/pages/components/map.vue